<template>
  <!-- role="list" is intentional: Safari VoiceOver strips list semantics from <ul> with list-style:none (Tailwind). https://www.scottohara.me/blog/2019/01/12/lists-and-safari.html -->
  <!-- eslint-disable-next-line vuejs-accessibility/no-redundant-roles -->
  <ul role="list" class="grid gap-16 grid-cols-2 md:grid-cols-4 lg:grid-cols-5">
    <slot />
  </ul>
</template>

<script lang="ts" setup></script>

<style></style>
